t = require('views/internal/teacup-with-helpers')('org_prefs_nonorg_invites')

module.exports = t.renderable (data) ->
  { externalMembersDisabled } = data

  t.div { style: 'margin: 12px 0 0;' }, ->

    t.p ->
      t.format 'who-can-be-added-to-team-boards'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', ->

      t.li { class: t.classify('active': externalMembersDisabled) }, ->
        t.a { href: '#' }, ->
          t.format 'only-team-members'

      t.li { class: t.classify('active': !externalMembersDisabled) }, ->
        t.a { href: '#' }, ->
          t.format 'anybody'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_prefs_nonorg_invites.coffee